import { render, staticRenderFns } from "./OptionsFilter.vue?vue&type=template&id=158dc6e2&scoped=true&"
import script from "./OptionsFilter.vue?vue&type=script&lang=js&"
export * from "./OptionsFilter.vue?vue&type=script&lang=js&"
import style0 from "./OptionsFilter.vue?vue&type=style&index=0&id=158dc6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158dc6e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VIcon,VRadio,VRadioGroup})
